/* tslint:disable */
/* eslint-disable */
/**
 * Client Signup API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { BlacklistedDomain } from './';
import {
    BlacklistedDomainFromJSON,
    BlacklistedDomainFromJSONTyped,
    BlacklistedDomainToJSON,
} from './';

/**
 * 
 * @export
 * @interface AutoEdrBlacklistedDomains
 */
export interface AutoEdrBlacklistedDomains {
    /**
     * 
     * @type {Array<BlacklistedDomain>}
     * @memberof AutoEdrBlacklistedDomains
     */
    domains?: Array<BlacklistedDomain>;
}

/**
 * Check if a given object implements the AutoEdrBlacklistedDomains interface.
 */
export function instanceOfAutoEdrBlacklistedDomains(value: object): value is AutoEdrBlacklistedDomains {
    return true;
}

export function AutoEdrBlacklistedDomainsFromJSON(json: any): AutoEdrBlacklistedDomains {
    return AutoEdrBlacklistedDomainsFromJSONTyped(json, false);
}

export function AutoEdrBlacklistedDomainsFromJSONTyped(json: any, ignoreDiscriminator: boolean): AutoEdrBlacklistedDomains {
    if (json == null) {
        return json;
    }
    return {
        
        'domains': json['domains'] == null ? undefined : ((json['domains'] as Array<any>).map(BlacklistedDomainFromJSON)),
    };
}

export function AutoEdrBlacklistedDomainsToJSON(value?: AutoEdrBlacklistedDomains | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'domains': value['domains'] == null ? undefined : ((value['domains'] as Array<any>).map((v) => BlacklistedDomainToJSON(v))),
    };
}

